export default __webpack_public_path__ + "static/media/my-to-do-list.8f4c9552.png";